import { hashes } from "dstucrypt-algos";

import { IKeyidAlgo } from "@prostocheck/shared";

/**
 * OIDs the container walk recognises, mapped to the names `dstucrypt-algos`'s
 * `storeload` dispatches on. The two ДСТУ ones are the whole reason this module
 * exists — jkurwa 1.22.7 has no entry for either.
 */
export const CONTAINER_OID: Record<string, string> = {
  "1.2.840.113549.1.12.10.1.2": "pkcs8ShroudedKeyBag",
  "1.2.840.113549.1.5.13": "PBES2",
  "1.2.840.113549.1.5.12": "PBKDF2",
  "1.2.804.2.1.1.1.1.2.2.4": "Dstu7564mac-256",
  "1.2.804.2.1.1.1.1.1.3.5.2": "Dstu7624cbc-256",
};

/** KMAC-Купина key derivation — the marker of a post-2022 container. */
export const MODERN_KDF_NAME = "Dstu7564mac-256";

/** Калина-256 in CBC — the other marker. */
export const MODERN_CIPHER_NAME = "Dstu7624cbc-256";

/** DER tag bytes used by the walk. */
export const DER_TAG = {
  integer: 0x02,
  octetString: 0x04,
  oid: 0x06,
  sequence: 0x30,
  set: 0x31,
} as const;

/** Bit 6 of a DER tag: the value is itself a TLV sequence to descend into. */
export const DER_CONSTRUCTED_BIT = 0x20;

/** Bit 8 of a DER length byte: long form, low 7 bits give the length-of-length. */
export const DER_LONG_FORM_BIT = 0x80;

/** Калина has a 256-bit block, so a PKCS#7 pad is never longer than this. */
export const MAX_PKCS7_PAD_LENGTH = 32;

/**
 * The hash a ЦСК indexes a modern certificate by — Купина, not ГОСТ 34.311.
 * Handed to jkurwa's `pub().keyid(algo)` when building the CMP lookup for a key
 * read out of a modern container.
 */
export const KUPYNA_KEYID_ALGO: IKeyidAlgo = {
  hash: hashes["Dstu7564-256"],
};
